import styled from "styled-components";

export const ContainerWrapper = styled.div`
    margin: 0 15px;
    @media (min-width:801px)  {
        margin: 0 200px;
    }  
`;